var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseListPage',{attrs:{"locale-section":"pages.municipalities","route":"municipality"}},[_c('MunicipalitiesList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }